module.exports = __webpack_public_path__ + "img/semiconductor_solution_bg_img01.e069dac8.png";